import React from 'react'
import PhotoSwipeGallery from '../../components/Gallery'
import { Box } from '@chakra-ui/react'
import SectionHeader from '../../components/SectionHeader'
import { useTranslation } from 'react-i18next'

const PageGallery = ({ gallery }) => {
    const { t } = useTranslation()

    return (
        gallery && (
            <Box pt={2} pb={12}>
                <Box display={'block'} pos={'relative'}>
                    <SectionHeader title={t('titles.gallery')} subtitle={t('subtitles.gallery')} />
                </Box>
                <Box px={[2, 4, 4, 12]}>
                    <PhotoSwipeGallery images={gallery} />
                </Box>
            </Box>
        )
    )
}

export default PageGallery
